import React, { useState, useEffect } from 'react';
import MaterialTable, { Column } from 'material-table';
import { firestore } from '../../firebase/firebase';
import { SuspectUser } from '../../models/SuspectUser';

const SuspectCase: React.FC = () => {
  const columns: Column<SuspectUser>[] = [
    { title: 'Name', field: 'name', searchable: false },
    { title: 'IC No.', field: 'icNumber', searchable: true },
    { title: 'Contact Number', field: 'contactNumber', searchable: false },
    { title: 'Email', field: 'email', searchable: false },
  ];

  const [loading, setLoading] = useState(true);
  const [closeContactUsers, setCloseContactUsers] = useState<SuspectUser[]>([]);

  useEffect(() => {
    setLoading(true);

    const fetchYellowUsers = async () => {
      try {
        const snapshot = await firestore
          .collection('users')
          .where('healthStatus', '==', 'yellow')
          .orderBy('name', 'asc')
          .get();

        if (!snapshot.empty) {
          const closeContacts = snapshot.docs.map((doc) => {
            return new SuspectUser(
              doc.id,
              doc.get('name'),
              doc.get('icNumber'),
              doc.get('contactNumber'),
              doc.get('email')
            );
          });

          setCloseContactUsers(closeContacts);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchYellowUsers();
  }, []);

  const getPageSize = (): number => {
    if (closeContactUsers.length < 5) {
      return 5;
    } else if (closeContactUsers.length < 10) {
      return 10;
    } else if (closeContactUsers.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <>
      <MaterialTable
        isLoading={loading}
        key={closeContactUsers.length}
        localization={{
          toolbar: { searchPlaceholder: 'Search IC No.' },
        }}
        options={{
          search: true,
          pageSize: getPageSize(),
          pageSizeOptions: [],
          actionsColumnIndex: -1,
          //   exportButton: true,
        }}
        columns={columns}
        data={closeContactUsers}
        title="Suspect Cases"
      />
    </>
  );
};

export default SuspectCase;
